/**
 * Aviso de estado: error, información o éxito.
 *
 * El icono y el color no son lo único que distingue el tipo: también lleva el
 * texto, porque el color por sí solo no funciona con daltonismo y porque el
 * mensaje es lo que dice qué hacer a continuación.
 *
 * @param {{
 *   tipo?: 'error' | 'info' | 'exito',
 *   titulo?: string,
 *   children?: React.ReactNode,
 *   accion?: React.ReactNode,
 * }} props
 */
export function Aviso({ tipo = 'info', titulo, children, accion }) {
  const estilos = {
    error: 'bg-peligro-50 text-peligro-900 ring-peligro-200 dark:bg-peligro-500/15 dark:text-peligro-200 dark:ring-peligro-500/30',
    info: 'bg-brand-50 text-brand-900 ring-brand-200 dark:bg-brand-100/20 dark:text-brand-200 dark:ring-brand-500/30',
    exito: 'bg-ok-50 text-ok-900 ring-ok-200 dark:bg-ok-500/15 dark:text-ok-200 dark:ring-ok-500/30',
  };

  // `alert` en los errores: un lector de pantalla lo anuncia en cuanto aparece.
  // En `info` y `exito` no, porque interrumpir en cada guardado molesta más de
  // lo que ayuda.
  const papel = tipo === 'error' ? 'alert' : 'status';

  return (
    <div
      role={papel}
      className={`flex flex-wrap items-start gap-3 rounded-lg px-4 py-3 text-sm ring-1 ring-inset ${estilos[tipo]}`}
    >
      <div className="min-w-0 flex-1">
        {titulo ? <p className="font-medium">{titulo}</p> : null}
        {children ? <div className={titulo ? 'mt-1' : ''}>{children}</div> : null}
      </div>
      {accion}
    </div>
  );
}
